export const STATUS_COURSES = 'STATUS_COURSES'
export const FETCH_COURSES = 'FETCH_COURSES'
export const WATCH_COURSE = 'WATCH_COURSE'
export const MESSAGE_COURSE = 'MESSAGE_COURSE'